import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import FormCrearMateria from "../formCrear/formCrearMateria";
import FormEditMateria from "../formEditar/formEditMateria";
import FormEditCategoria from "../formEditar/editCategoria";
import FormCrearCategoria from "../formCrear/crearCategoria";
import "./tabla.css";
import Header from "../Header/header";


const TablaMaterias = () => {
  const [materia, setData] = useState([]);
  const [categoria, setCategoria] = useState([]);
  const [showModalDel, setShowModalDel] = useState(false);
  const [showModalDelC, setShowModalDelC] = useState(false);

  const [showModalEditCat, setShowModalEditCat] = useState(false);
  const [categoriaAEditar, setCategoriaAEditar] = useState(null);


  const [EliminarC, setEliminarC] = useState();
  const [Eliminar, setEliminar] = useState();
  const [showModalCreateCat, setShowModalCreateCat] = useState(false);

  const handleCloseCreateCat = () => setShowModalCreateCat(false);

  const handleCloseDel = () => { setShowModalDel(false) }
  const handleCloseDelC = () => { setShowModalDelC(false) }

  const handleShowDel = (id) => {
    setEliminar(id);

    setShowModalDel(true);

  };
  const handleShowDelC = (id) => {
    setEliminarC(id);

    setShowModalDelC(true);

  };

  const handleSubmit = () => {

    fetch(`http://localhost:8080/api/producto/${Eliminar}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'authorization': sessionStorage.getItem('token')
      },
    })
      .then((response) => {
        if (response.ok) {
          console.log('Elemento eliminado con éxito');
          setShowModalDel(false);


        } else {
          console.error('Error al eliminar el producto');

        }
      })
      .catch((error) => {
        console.error('Error de red:', error);
      });
  }
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };
  const filteredData = materia.filter((item) => {
    const materia = item.nombre;
    const searchTermLowerCase = searchTerm.toLowerCase();
    const materiaLowerCase = materia.toLowerCase();
    const materiaSeparados = materiaLowerCase.split(' ');
    return materiaSeparados.some((part) => part.startsWith(searchTermLowerCase));
  });

  //Modal Crear Materia
  const [showModalCreate, setShowModalCreate] = useState(false);
  const handleShowCreate = () => setShowModalCreate(true);

  //modal ver categorias
  const [showModalCat, setShowModalCat] = useState(false);


  const handleCloseEditCat = () => {
    setShowModalEditCat(false);
    setCategoriaAEditar(null); // Limpiar los datos de la categoría a editar
  };



  const handleShowCat = () => {
  
    setShowModalCat(true);
  };

  const handleShowEditCat = (categoryId) => {
    const categoryToEdit = categoria.find((cat) => cat.id === categoryId);
    if (categoryToEdit) {
      setCategoriaAEditar(categoryToEdit);
      setShowModalEditCat(true);
    }
  };

  useEffect(() => {

    const requestOptions = {
      method: 'GET', // Método GET
      headers: {
        'Content-Type': 'application/json',
        'authorization': sessionStorage.getItem('token')
      }

    };

 
   fetch("http://localhost:8080/api/categoria", requestOptions)
    .then((response) => response.json())
     .then((data) => setCategoria(data))
     .catch((error) => console.error(error));


     

  
  }, [showModalEditCat,showModalDelC,showModalCreateCat]);



  //Modal Editar Materia
  const [materiaAEditar, setMateriaAEditar] = useState(null); // Nuevo estado
  const [showModalEdit, setShowModalEdit] = useState(false);

  const handleShowEdit = (id) => {
    const materiaParaEditar = materia.find((materia) => materia.id_producto === id);
    if (materiaParaEditar) {
      setMateriaAEditar(materiaParaEditar);
      setShowModalEdit(true);
    }
  };



  const handleClose = () => {
    setShowModalCreate(false);
    setShowModalEdit(false);
    setShowModalCat(false)


  };

  useEffect(() => {

    // Opciones personalizadas para el fetch
    const requestOptions = {
      method: 'GET', // Método GET
      headers: {
        'Content-Type': 'application/json',
        'authorization': sessionStorage.getItem('token')
      }

    };


    fetch("http://localhost:8080/api/producto", requestOptions)
      .then(response => response.json())
      .then(data => setData(data))
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Request aborted');
        } else {

        }
      })

  }, [showModalDel, showModalCreate, showModalEdit,showModalEditCat]);

 //delete categoria





// Handler para abrir el modal de confirmación de eliminación de categoría


 const handleDeleteCategoria = () => {
  fetch(`http://localhost:8080/api/categ/${EliminarC}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'authorization': sessionStorage.getItem('token')
    },
  })
    .then((response) => {
      if (response.ok) {
        console.log('Categoría eliminada con éxito');
        setShowModalDelC(false); // Cerrar modal de confirmación después de eliminar
      } else {
        console.error('Error al eliminar la categoría');
      }
    })
    .catch((error) => {
      console.error('Error de red:', error);
    });
};

  return (
    <>
      <Header></Header>

      <div className="container">
        <div className="row justify-content-center align-items-center g-2">
          
          
          <div className="col-4"><h3>Administracion de Productos</h3></div>
          <div className="col-4"><button onClick={handleShowCat} className="btn btn-dark">Categorias</button></div>
          <div className="col-4 offset-4"><button className="btn btn-dark"><a className="text-decoration-none text-white" target="_blank" rel="noopener noreferrer"  href="https://preciosestacion.netlify.app/">Ver Lista</a></button> </div>
          
          <div className="col-2">
            <button onClick={handleShowCreate} className="btn btn-dark">Agregar Producto</button>
          </div>
          <div className="col-4 offset-4">
            <div className="input-group mb-3">
              <input
                className="form-control"
                type="text"
                placeholder="Buscar Producto"
                onChange={handleSearch}
                value={searchTerm}
              />
              <span className="btn btn-dark">Buscar</span>
            </div>
          </div>
        </div>
<br></br>

        <table className="table-dark table text-center    table-hover custom-table">
          <thead className=" titulo_tabla">
            <tr >
              <th scope="col">NOMBRE</th>
              <th scope="col">CATEGORIA</th>
              <th scope="col">PRECIO x KG</th>
              <th scope="col">DISPONIBILIDAD</th>
              <th scope="col">DESCRIPCION</th>
              <th scope="col">IMAGEN</th>
              <th scope="col">ACCIONES</th>
            </tr>
          </thead>
          <tbody className=" cuerpo_tabla">
            {filteredData.map((materia, index) => (
              <tr key={index}>
                <td>{materia.nombre}</td>
                <td>{materia.categoria}</td>
                <td>${materia.precio}</td>
                <td>{materia.disponible === 0 ? "Disponible" : "No Disponible"}</td>
                <td>${materia.descripcion}</td>
                <td>
                  {materia.imagen ?
                    <img
                      src={`http://localhost:8080/upload/${materia.imagen}`}
                      alt="Imagen del producto"
                      className="img-thumbnail"
                    />
                    : "No hay imagen"}
                </td>
                <td>
                  <div className="btn-group" role="group" aria-label="Basic example">
                    <button type="button" onClick={() => handleShowEdit(materia.id_producto)} className="btn btn-primary">Editar</button>
                    <button onClick={() => handleShowDel(materia.id_producto)} type="button" className="btn btn-danger">Borrar</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className=" container modal-body">


      <Modal show={showModalDelC} onHide={handleCloseDelC}>
        <Modal.Body>
          <div className="container text-center">
            <strong>¿Está seguro que desea eliminar esta categoría?</strong>
            <div className="row">
              <div className="col">
                <button onClick={() => handleDeleteCategoria()} className="btn btn-danger">Eliminar</button>
              </div>
              <div className="col offset-1">
                <button className="btn btn-dark" variant="secondary" onClick={handleCloseDelC}>Cancelar</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showModalCat} onHide={() => setShowModalCat(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Categorías</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button onClick={() => setShowModalCreateCat(true)}>
            Crear Nueva Categoría
          </Button>
          <br></br>
          <br></br>
          <table className=" table text-center table-hover custom-table">
            <thead className="titulo_tabla">
              <tr>
                <th scope="col">NOMBRE</th>
                <th scope="col">Imagen</th>
                <th scope="col">ACCIONES</th>
              </tr>
            </thead>
            <tbody className="cuerpo_tabla">
              {categoria.map((cat) => (
                <tr key={cat.id}>
                  <td>{cat.nombre.toUpperCase()}</td>
                  <td>{cat.imagen}</td>
                  <td>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleShowEditCat(cat.id)}
                    >
                      Editar
                    </button>
                    
                    <button
                      className="btn btn-danger"
                      onClick={() => handleShowDelC(cat.id)}
                    >
                      Borrar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>

      <Modal show={showModalEditCat} onHide={handleCloseEditCat}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Formulario para editar categorías */}
          <FormEditCategoria
            data={categoriaAEditar}
            handleClose={handleCloseEditCat}
          />
        </Modal.Body>
      </Modal>

      <Modal show={showModalCreateCat} onHide={handleCloseCreateCat}>
      <Modal.Header closeButton>
          <Modal.Title>Crear Categoría</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        
          <FormCrearCategoria
           
            handleClose={handleCloseCreateCat}
          />
        </Modal.Body>
      </Modal>
        
      <Modal   show={showModalEdit || showModalCreate} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{showModalEdit ? 'Editar producto' : 'Crear producto'}</Modal.Title>
        </Modal.Header>
        <Modal.Body >
          {showModalEdit ? <FormEditMateria data={materiaAEditar} handleClose={handleClose} /> : <FormCrearMateria handleClose={handleClose} />}
        </Modal.Body>
      </Modal>

        </div>              
     
        <div className=" container modal-body">
      <Modal show={showModalDel} onHide={handleCloseDel}>
        <Modal.Body >
          <div className="container text-center">
            <strong>¿Está seguro que desea eliminar este producto?</strong>
            <div className="row">
              <div className="col">
                <button onClick={handleSubmit} className="btn btn-danger">Eliminar</button>
              </div>
              <div className="col offset-1">
                <button className="btn btn-dark" variant="secondary" onClick={handleCloseDel}>Cancelar</button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      </div>  
    </>
  );
}

export default TablaMaterias;